import React, {Component, useContext} from 'react'
import PropTypes from 'prop-types'
import Analytics from '@cred/react-analytics'

const SnowplowReactContext = React.createContext([]),

  /*
  * Adds Snowplow props to the component:
  * - spContexts: List of Snowplow contexts.
  * - trackSnowplowEvent: Auxiliary function to fire SP events.
  */
  withSnowplowContexts = WrappedComponent => {
    const ComponentWithSnowplowContexts = props => {
      const ctx = useContext(SnowplowReactContext),

        /*
        * Method used to facilitate firing events that are specifically not attached to components.
        * - event: One of the events from ../events/index.js.
        * - data: Data sent to the event according to ../events/index.js.
        * - spContexts: Array of Snowplow contexts (../contexts/index.js). If not used, function
        *     will use the Snowplow contexts of the component previously set by <SnowplowContext>.
        */
        trackSnowplowEvent = (event, data, spContexts = ctx) => {
          const analytics = new Analytics(event.analytics(null, spContexts))

          analytics.event(data)
        }

      return <WrappedComponent spContexts={ctx} trackSnowplowEvent={trackSnowplowEvent} {...props}/>
    }

    return ComponentWithSnowplowContexts
  }

class SnowplowContext extends Component {
  static propTypes = {contexts: PropTypes.array.isRequired}

  render() {
    const {children, contexts} = this.props

    return (
      <SnowplowReactContext.Consumer>
        {value =>
          <SnowplowReactContext.Provider value={contexts.concat(value)}>
            {children}
          </SnowplowReactContext.Provider>
        }
      </SnowplowReactContext.Consumer>
    )
  }
}

export {SnowplowReactContext, SnowplowContext, withSnowplowContexts}
